import React from 'react';

import Heading from '../../Heading';
import removeNewlines from '../../../utils/string/removeNewlines';

import * as S from './styles';

// Types
import { CMS_ENUM_SECTION_BACKGROUNDPATTERN } from '../../../../types/global';
import { FluidImage } from '../../MediaImage/GatsbyImageWrapperFluid/GatsbyImageWrapperFluid';
import { ReactNode } from 'react';
import { SectionWidth } from '../../../../types/sections';

type Props = {
  backgroundColor: string | null;
  backgroundImage: FluidImage | null;
  backgroundPattern: CMS_ENUM_SECTION_BACKGROUNDPATTERN | null;
  contentPositionX: string;
  contentPositionY: string;
  headline: string;
  headlineTextColor: string;
  index: number;
  isClipped: boolean;
  isCritical: boolean;
  isHiddenOnMobile: boolean;
  isNeighborClipped: boolean;
  sectionWidth: SectionWidth;
  splitHeadline: ReactNode;
  splitText: ReactNode;
  textColor: string;
  url: string | null;
};

const SectionHomeContentPageTeaser = ({
  backgroundColor,
  backgroundImage,
  backgroundPattern,
  contentPositionX,
  contentPositionY,
  headline,
  headlineTextColor,
  index,
  isClipped,
  isCritical,
  isHiddenOnMobile,
  isNeighborClipped,
  sectionWidth,
  splitHeadline,
  splitText,
  textColor,
  url,
}: Props) => {
  const headlineWithoutNewlines = removeNewlines(headline);

  return (
    <S.Section
      backgroundColor={backgroundColor}
      backgroundImage={backgroundImage}
      backgroundPattern={backgroundPattern}
      contentPositionX={contentPositionX}
      contentPositionY={contentPositionY}
      index={index}
      isClipped={isClipped}
      isCritical={isCritical}
      isHiddenOnMobile={isHiddenOnMobile}
      isNeighborClipped={isNeighborClipped}
      sectionWidth={sectionWidth}
    >
      {!!headlineWithoutNewlines && <Heading isVisuallyHidden={true}>{headlineWithoutNewlines}</Heading>}

      <S.Headline aria-hidden={!!headlineWithoutNewlines} textColor={headlineTextColor}>
        {splitHeadline}
      </S.Headline>

      {!!url ? (
        <S.ContentWrapper>
          <S.ContentLink headlineTextColor={headlineTextColor} textColor={textColor} url={url}>
            {splitText}
          </S.ContentLink>
        </S.ContentWrapper>
      ) : (
        <S.Content headlineTextColor={headlineTextColor} textColor={textColor}>
          {splitText}
        </S.Content>
      )}
    </S.Section>
  );
};

export default SectionHomeContentPageTeaser;
